import React from 'react';
import './index.css';
import './App.css';
import { Routes,Route} from 'react-router-dom';
import { Result, Home } from './page.js';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className='container'>
          <Routes>
            <Route path='/' element={<Home/>}></Route>
            <Route path='/result' element={<Result/>}></Route>
          </Routes>
        </div>
      </header>
    </div>
  );
}

export default App;
